(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TestScheduleDialogNextController', TestScheduleDialogNextController);

    TestScheduleDialogNextController.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService', 'TabObjects', '$timeout', 'name', 'fleet', 'objType', 'tests', 'objects', 'testSchedule', '$uibModal', '$filter', 'TestSchedule', 'include'];

    function TestScheduleDialogNextController($scope, $state, ParseLinks, AlertService, TabObjects, $timeout, name, fleet, objType, tests, objects, testSchedule, $uibModal, $filter, TestSchedule,include) {
        var vm = this;

        vm.testSchedule = testSchedule;
        vm.fleet = fleet;
        vm.objType = objType;
        vm.tests = tests;
        vm.tabObjects = objects;
        vm.scheduleName = name;
        vm.isActive = include;
        vm.loadAll = loadAll;

        function loadAll() {
            if (!(fleet && objType && tests && objects)) {
                $state.transitionTo('test-schedule', {});
            }
            if(vm.testSchedule != null) {
                checkSelectedObjects(vm.testSchedule.objects);
            }
            function checkSelectedObjects(selectedObjects) {
                vm.tabObjects.forEach(function (object) {
                    object.check = false;
                    selectedObjects.forEach(function (selectedObject) {
                        if (object.id === selectedObject.id)
                            object.check = true;
                    });
                });
                vm.tabObjects.sort((a,b) => b.check - a.check);
            }
        }

        vm.checkAll = function () {
            vm.tabObjects.forEach(function (object) {
                object.check = vm.areChk;
            });
        }

        vm.areAllChecked = function () {
            var allChecked = true;
            var notChecked = true;
            vm.tabObjects.forEach(function (object) {
                allChecked = object.check && allChecked;
                notChecked = !object.check && notChecked;
            });
            if(allChecked) vm.areChk = allChecked;
            else if(notChecked) vm.areChk = !notChecked;
        }

        vm.clickedAtLeastOneObject = function () {
            var isChecked = false;
            vm.tabObjects.forEach(function (object) {
                isChecked = isChecked || object.check
            });
            return isChecked;
        }

        function selectedObjects() {
            var selectedObjects = [];
            vm.tabObjects.forEach(function (object) {
                if(object.check)
                    selectedObjects.push(object);
            });
            return selectedObjects;
        }

        loadAll();

        vm.back = function () {
            if(vm.testSchedule == null) {
                $state.transitionTo('test-schedule.new', {
                    name: vm.scheduleName,
                    fleet: vm.fleet,
                    objType: vm.objType,
                    tests: vm.tests,
                    include: vm.isActive
                }, {location: "replace"});
            }
            else {
                $state.transitionTo('test-schedule.edit', {
                    id: vm.testSchedule.id,
                    name: vm.scheduleName,
                    fleet: vm.fleet,
                    objType: vm.objType,
                    tests: vm.tests,
                    include: vm.isActive
                }, {location: "replace"});
            }
        }

        vm.scheduleTest = function () {
            if (vm.showSchedule === undefined)
                vm.response = {
                    single: false,
                    afterLaunch: false,
                    scheduleName: vm.scheduleName
                };
            $uibModal.open({
                templateUrl: 'app/entities/test-schedule/schedule-object-test.html',
                controller: 'ScheduleObjectTestController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: function () {
                        return vm.response;
                    }
                }
            }).result.then(function (result) {
                if (result.scheduleDateTime !== undefined || result.selectedDay !== undefined) {
                    vm.response = result;
                    vm.tabScheduleTest = {};
                    if (vm.response.single) {
                        setData();
                    } else {
                        setMultipleData();
                    }
                    vm.saveScheduleTest();
                } else
                    vm.showSchedule = undefined;
            })
        };

        function setData() {
            vm.tabScheduleTest.scheduleDateTime = vm.response.scheduleDateTime;
            vm.repeatNumber = vm.response.repeatNumber;
            convertDate();
        }

        function convertDate(){
            if(vm.repeatNumber) {
                var dateFormat = 'dd/MM/yyyy';
                var date = $filter('date')(new Date(vm.tabScheduleTest.scheduleDateTime), dateFormat);
                vm.showSchedule = "SCHEDULED: " + date + "\n" + " REPEAT EVERY " + vm.repeatNumber  + " " + "DAYS";
            } else {
                AlertService.error("Fill Repetition field");
                vm.showSchedule = undefined;
            }
        }

        function setMultipleData() {
            vm.tabScheduleTest.weeklyCron = [];
            vm.showSchedule = "SCHEDULED:\nREPEAT\n";
            angular.forEach(vm.response.selectedDay, function(day){
                if(day.selectedTime) {
                    var schedule = convertWeeklyDate(day);
                    vm.showSchedule += schedule;
                }
            });
            vm.showSchedule = vm.showSchedule.slice(0, -1);
        }

        function convertWeeklyDate(day) {
            var dateFormat = 'HH:mm';
            var tempDate = angular.copy(day.selectedTime);
            var date = $filter('date')(new Date(convertToUTC(tempDate)), dateFormat);
            var cron = date.split(":");
            vm.tabScheduleTest.weeklyCron.push(cron[1] + " " + cron[0] + " " + checkDay(day.day));

            var dateToShow = $filter('date')(new Date(day.selectedTime), dateFormat);
            return " " + day.day + " EVERY " + dateToShow + "\n";
        }

        function convertToUTC(date) {
            var offset = new Date().getTimezoneOffset();
            var hours = Math.floor(offset/60);
            var minutes = offset % 60;
            date.setHours(date.getHours() + hours);
            date.setMinutes(date.getMinutes() + minutes);
            return date;
        }

        function checkDay(day) {
            switch (day){
                case "MON":
                    return 1;
                case "TUE":
                    return 2;
                case "WED":
                    return 3;
                case "THU":
                    return 4;
                case "FRI":
                    return 5;
                case "SAT":
                    return 6;
                case "SUN":
                    return 7;
            }
        }

        vm.saveScheduleTest = function () {
            vm.isSaving = true;
            vm.tabScheduleTest.name = vm.scheduleName;
            vm.tabScheduleTest.single = vm.response.single;
            if(vm.tabScheduleTest.single && vm.repeatNumber){
                vm.tabScheduleTest.cronExpression = vm.repeatNumber;
            }
            vm.tabScheduleTest.multipleSchedule = true; //it's a multiple object schedule
            vm.tabScheduleTest.testSettings = vm.tests;
            vm.tabScheduleTest.tabObjects = selectedObjects();
            vm.tabScheduleTest.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            vm.tabScheduleTest.includeOffline = vm.isActive;

            TestSchedule.create(vm.tabScheduleTest, onSuccess, onError);
        };

        function onSuccess() {
            $state.transitionTo('test-schedule', {}, {notify: true, location: "replace", reload: true});
        }

        function onError(error) {}

        vm.update = function () {
            TestSchedule.update({
                id: vm.testSchedule.id,
                name: vm.scheduleName,
                tests: vm.tests,
                includeOffline : vm.isActive,
                objects: selectedObjects()
            }, onSuccess, onError);
        }
    }
})();
